import Consult from '../page/team/consult'
import Detail from '../page/team/detail'
import ConsultDetail from '../page/team/consult-detail'
import Rate from '../page/team/rate'

export default [
  {
    path: "/team/:id/consult",
    component: Consult
  },
  {
    path: "/team/:id/detail",
    component: Detail
  },
  {
    path: "/team/:id/rate",
    component: Rate
  },
  {
    path: "/team/consult/:id",
    component: ConsultDetail
  },
  {
    path: "/team/list",
    component: () => import('../page/team/list')
  },
  /**
   * 服务详情页
   * @query.teamId
   * @query.serverId
   */
  {
    path: "/team/server",
    component: () => import('../page/team/server')
  },
  /**
   * 服务介绍
   * @query.serverId
   * @query.consultId
   */
  {
    path: '/team/server/info',
    component: () => import('../page/team/server/info')
  },
  /**
   * 文件下载
   */
  {
    path: '/team/download',
    component: () => import('../page/team/download')
  }
]



// WEBPACK FOOTER //
// ./src/router/team.js